import { render, staticRenderFns } from "./PurchaseOrders.vue?vue&type=template&id=ab2fb436"
import script from "./PurchaseOrders.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrders.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports